import { DialogTitle, Divider, GridProps, useTheme } from '@mui/material';
import { ContextForm, IFormAfterSubmit, InputOnlyField, Select } from '@ngt/forms';
import { ValidateOn } from '@ngt/forms-core';
import { FC, useCallback, useContext } from 'react';
import { UserAgentLocation } from '../../api/dtos';
import ProjectAgentLocationSummariesContext from '../../contexts/ProjectAgentLocationsContext';
import { IFormDialogProps, StyledButton, StyledDialog, StyledDialogActions, StyledDialogContent, StyledFormColumn, StyledFormSubmitButton } from '../inputs/CommonFormElements';

const COLUMN_SIZING: GridProps['size'] = {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 6
} 

const AgentProjectForm: FC<IFormDialogProps> = (props) => {
    const theme = useTheme();
    const { refresh: refreshAgentLocations } = useContext(ProjectAgentLocationSummariesContext);
    

    const onAfterSubmit: IFormAfterSubmit<UserAgentLocation> = useCallback(async (_newValue, _formState, _formActions) => {
        await refreshAgentLocations();
        props.onClose();
    }, [refreshAgentLocations, props.onClose])

    return (
        <ContextForm
            onAfterSubmit={onAfterSubmit}
            validateOn={ValidateOn.onChange}
            validateOnReset
        >
            <StyledDialog {...props}>
                <DialogTitle
                    sx={{
                        backgroundColor: theme.palette.secondary.light,
                        color: "white"
                    }}
                >
                    {props.edit ? "Edit" : "Add"} Agent Project
                </DialogTitle>
                <StyledDialogContent>
                    <StyledFormColumn
                        size={COLUMN_SIZING}
                    >
                        <InputOnlyField 
                            label="Agent"
                            component={Select}
                            propertyPath={'agentLocationId'}
                            MenuProps={{
                                sx: {
                                    maxHeight: 500
                                }
                            }}
                        />
                        <InputOnlyField 
                            label="Project"
                            component={Select}
                            propertyPath={'projectId'}
                            MenuProps={{
                                sx: {
                                    maxHeight: 500
                                }
                            }}
                        />
                    </StyledFormColumn>
                </StyledDialogContent>
                <Divider />
                <StyledDialogActions>
                    <StyledFormSubmitButton variant="contained">Submit</StyledFormSubmitButton>
                    <StyledButton variant="contained" onClick={props.onClose}>Cancel</StyledButton>
                </StyledDialogActions>
            </StyledDialog>
        </ContextForm>
    );
}

export default AgentProjectForm;